import React from 'react'
import { Modal } from "antd";

const UGModal = ({ modal, title, handleCancel, children, t, ...rest }) => {
    return (
        <>
            <Modal
                className="view-details-modal"
                visible={modal}
                title={<div className="detail-header">{title}</div>}
                width={rest?.width ? rest?.width : "1130px"}
                onOk={() => { }}
                onCancel={handleCancel}
                {...rest}
                destroyOnClose
            >
                {children}
            </Modal>
        </>
    )
}

export default UGModal
